// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5eDS6xMjrue0QP1yHHygLA\\=\\={position:absolute;width:100%;height:100%;top:0;left:0;z-index:9}.ILP1vog8\\+gL9ARjWzsYYRA\\=\\={width:auto;height:auto;position:absolute;white-space:nowrap}", "",{"version":3,"sources":["webpack://./src/shared/components/Tutorial/TutorialManager.module.scss"],"names":[],"mappings":"AAAA,6BACE,iBAAA,CACA,UAAA,CACA,WAAA,CACA,KAAA,CACA,MAAA,CACA,SAAA,CAGF,6BACE,UAAA,CACA,WAAA,CACA,iBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlighterOverlay": "_5eDS6xMjrue0QP1yHHygLA==",
	"innerCard": "ILP1vog8+gL9ARjWzsYYRA=="
};
export default ___CSS_LOADER_EXPORT___;
